
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'FETCH_DATA_SUCCESS',
    payload:data
})

export const fetchdata = (uid:any,donorid:any,rid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,fund:donorid,year:rid};
            const apiname = orgapi.orgdonrep;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}


